// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._19itidpf{border:0}._18m915vq{overflow-y:hidden}
._19bvidpf{padding-left:0}
._1bsbt94y{width:1px}
._1pbydx66{z-index:9999}
._1reo15vq{overflow-x:hidden}
._4t3it94y{height:1px}
._ca0qidpf{padding-top:0}
._jqf6ydhy{label:a11yText}
._kqswstnw{position:absolute}
._n3tdidpf{padding-bottom:0}
._o5721q9c{white-space:nowrap}
._ogto7mnp{clip:rect(1px,1px,1px,1px)}
._u5f3idpf{padding-right:0}
._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/react-select/dist/esm/compiled/components/internal/a11y-text.compiled.css"],"names":[],"mappings":";AACA,WAAW,QAAQ,CAAC,WAAW,iBAAiB;AAChD,WAAW,cAAc;AACzB,WAAW,SAAS;AACpB,WAAW,YAAY;AACvB,WAAW,iBAAiB;AAC5B,WAAW,UAAU;AACrB,WAAW,aAAa;AACxB,WAAW,cAAc;AACzB,WAAW,iBAAiB;AAC5B,WAAW,gBAAgB;AAC3B,WAAW,kBAAkB;AAC7B,WAAW,0BAA0B;AACrC,WAAW,eAAe;AAC1B,WAAW,wBAAwB,CAAC,oBAAoB,CAAC,gBAAgB","sourcesContent":["\n._19itidpf{border:0}._18m915vq{overflow-y:hidden}\n._19bvidpf{padding-left:0}\n._1bsbt94y{width:1px}\n._1pbydx66{z-index:9999}\n._1reo15vq{overflow-x:hidden}\n._4t3it94y{height:1px}\n._ca0qidpf{padding-top:0}\n._jqf6ydhy{label:a11yText}\n._kqswstnw{position:absolute}\n._n3tdidpf{padding-bottom:0}\n._o5721q9c{white-space:nowrap}\n._ogto7mnp{clip:rect(1px,1px,1px,1px)}\n._u5f3idpf{padding-right:0}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
